import { canUser, ops } from '@weenat/client/dist/core/access'
import * as zodSchemas from '@weenat/client/dist/zod-schemas'
import { useIntl } from '@weenat/wintl'
import { Head, Redirect, useSearchParams } from 'app/routx-router'
import LoginAs from 'app/src/debug/components/LoginAs'
import HeaderActions from 'app/src/layouts/HeaderActions'
import { useLoginAs } from 'app/state'
import { useUserContext } from 'app/userProvider'

const search = zodSchemas.loginAs
export const settings = {
  search
}

const Debug = () => {
  const { t } = useIntl()
  const [loginAs] = useLoginAs()
  const [searchParams] = useSearchParams(settings.search)
  const { me } = useUserContext()
  const canView = canUser(ops.view, 'debugMode', { account: me }) || loginAs !== null
  if (!canView) return <Redirect to='/' />

  return (
    <>
      <Head title={t('titles.debug')} />
      <HeaderActions />
      <LoginAs
        initialEmail={searchParams?.login_as}
        unknownEmail={searchParams?.unknownEmail}
        redirect={searchParams?.redirect}
      />
    </>
  )
}
export const Component = Debug
export default Debug
